export const endpoints = {
  prepareIgDefaultReply: '/:currentAccountID/onboarding/prepareIgDefaultReply',
  prepareIgConversationStarters: '/:currentAccountID/onboarding/prepareIgConversationStarters',
  getCompletedTours: '/:currentAccountID/onboarding/completedTours',
  markTourCompleted: '/:currentAccountID/onboarding/markTourCompleted',
}
